import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { fetchSmsTemplates } from "../../../lib/api/resources/sms";
import { smsTemplateColumns } from "./lib/constants/smsTemplateColumns";
import { Link } from "react-router-dom";
import { Table } from "@/components/v2";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";

export const SmsTemplatesList = () => {
  const smsTemplatesQuery = useQuery({
    queryKey: ["smsTemplates"],
    queryFn: fetchSmsTemplates,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/sms-templates/create">
          <Button icon={<PlusOutlined />}>Nieuwe SMS template</Button>
        </Link>
      </Space>
      <Table
        columns={smsTemplateColumns}
        dataSource={smsTemplatesQuery.data?.member}
        loading={smsTemplatesQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
